import { externalId, timestamps, uuid } from '@snap-types/models/common';
import { decimal } from '@snap-types/schemas/decimal';
import { z } from 'zod/v4';

import { erpDBSchema } from '../site/enums';

export const columns = {
  id: uuid,
  externalId,
  customerId: z.string(),

  name: z.string(),
  attentionName: z.string().nullish(),
  address1: z.string().nullish(),
  address2: z.string().nullish(),
  city: z.string().nullish(),
  state: z.string().nullish(),
  postalCode: z.string().nullish(),
  countryCode: z.string(),
  phone: z.string().nullish(),
  email: z.string().nullish(),

  billingName: z.string().nullish(),
  billingAddress1: z.string().nullish(),
  billingAddress2: z.string().nullish(),
  billingCity: z.string().nullish(),
  billingState: z.string().nullish(),
  billingPostalCode: z.string().nullish(),
  billingCountryCode: z.string().nullish(),

  industry: z.string().nullish(),
  salesRepId: z.string().nullish(),

  termsId: z.string().nullish(),
  termsNetType: z.string().nullish(),
  termsNetDays: z.number().int().nullish(),
  termsDiscountType: z.string().nullish(),
  termsDiscountDays: z.number().int().nullish(),
  termsDiscountPercent: decimal.nullish(),
  termsDescription: z.string().nullish(),
  freightTerms: z.string().nullish(),

  companyId: z.string().nullish(),

  discountCode: z.string().nullish(),
  marketCode: z.string().nullish(),

  erpDB: erpDBSchema,

  ...timestamps,
  updatedByEtlAt: z.date().nullish(),
};
